import { Quote } from 'lucide-react'
import { STORE_NAME } from '../config'

const quotes = [
  {
    text: 'Transparent pricing and consistent documentation made onboarding effortless. Our landed costs dropped within the first quarter of working together.',
    role: 'Procurement Manager',
    context: 'FMCG distributor — Benelux'
  },
  {
    text: 'They handled a tricky multi-origin consolidation that two other traders walked away from. Delivered on schedule with paperwork in order.',
    role: 'Import Director',
    context: 'Regional trading house — Middle East'
  },
  {
    text: 'The quote process is straightforward — send the spec, get a landed price, approve, done. Exactly what a busy buying team needs.',
    role: 'Head of Buying',
    context: 'Food manufacturing — Central Europe'
  }
]

export function Testimonials() {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <span className="mb-3 inline-block rounded-full border border-brand-gold/40 bg-brand-gold/10 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-brand-navy">
          Testimonials
        </span>
        <h2 className="heading-accent font-display text-2xl font-bold text-brand-ink sm:text-3xl">
          What buyers say about {STORE_NAME}
        </h2>
        <p className="mt-4 max-w-2xl text-brand-slate">
          Long-term trading relationships are our real product — here is what working with us looks like from the buyer's side.
        </p>
        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          {quotes.map((q) => (
            <figure key={q.role + q.context} className="card-lift flex flex-col rounded-2xl border border-brand-slate/10 bg-white p-7 shadow-card">
              <Quote className="h-7 w-7 text-brand-gold" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-brand-slate">
                "{q.text}"
              </blockquote>
              <figcaption className="mt-5 border-t border-brand-slate/10 pt-4">
                <div className="text-sm font-semibold text-brand-ink">{q.role}</div>
                <div className="text-xs text-brand-slate">{q.context}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  )
}
